export default "__VITE_ASSET__CxSxQ36Z__"